import React, { useState, useEffect, useContext } from "react";
import Request from "common/Request";
import Result from "./Result";
import {
  parseSystemMemoryUsage,
  parsePoolMemoryUsage,
  parseDPDKMemoryUsage,
} from "./api.js";
import ActionsContext from "common/ActionsContext";
import View from "common/View";

export const memoryUsageRetrieval = () =>
  Promise.all([
    ifCl.run("show system memory").then(parseSystemMemoryUsage),
    ifCl.run("show pkteng memory").then(parsePoolMemoryUsage),
    ifCl.run("show pkteng memory dpdk").then(parseDPDKMemoryUsage),
  ]).then(([System, Mpool, Dpdk]) => ({ System, Mpool, Dpdk }));

const Report = () => {
  const actions = useContext(ActionsContext);
  const [request, setRequest] = useState(null);

  const doLoad = () => {
    setRequest(memoryUsageRetrieval());
  };

  useEffect(() => doLoad() || actions.recv("do-load", doLoad), []);

  return (
    <Request during={request}>
      {(response) => <Result {...response} />}
    </Request>
  );
};

const MemoryStatus = () => (
  <View title="Memory Usage">
    <Report />
  </View>
) 
export default MemoryStatus;
